export default __webpack_public_path__ + "static/media/logo.78630d77.png";